import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { Is_VatDeclaration_RequestType } from 'src/app/constants/request-type.enum';
import { ViewerRequestModel } from 'src/app/models/viewer/viewer-request-model.model';
import { ViewerRequestApiClient } from 'src/app/services/api-clients/viewer-request.api-client';
import { RequestApiClient } from 'src/app/services/api-clients/request.apiclient';
import { environment } from 'src/environments/environment';
import { StatusEnum } from 'src/app/constants/status.enum';

@Component({
  selector: 'app-ideal-payment-button',
  templateUrl: './ideal-payment-button.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class IdealPaymentButtonComponent {

  private _requestId!: any;
  paymentStatus: boolean = false;
  get requestId(): any {
    return this._requestId;
  }
  @Input() set requestId(val: any) {
    this._requestId = val;
    if (this._requestId && (Object.keys(this.request).length === 0)) {
      this.getRequestData();
    }
  }

  get showComponent(): boolean {
    return this.taxPaymentIntegrationEnabled() &&
      Is_VatDeclaration_RequestType(this.request.requestType) &&
      (this.request.status === StatusEnum.Filing || this.request.status === StatusEnum.PendingDigipoort || this.request.status === StatusEnum.Completed) &&
      Number.isFinite(Number(this.request.taxAmount)) && Number(this.request.taxAmount) > 0;
  }
  get displayPayButton(): boolean {
    return this.showComponent && !!this.paymentUrl;
  }

  environment: any = environment;
  paymentUrl: string | null = null;
  request: ViewerRequestModel = {} as ViewerRequestModel;

  constructor(private requestService: RequestApiClient, private viewerRequestApiClient: ViewerRequestApiClient) {
  }

  taxPaymentIntegrationEnabled(): boolean {
    return this.environment.enableTaxPaymentIntegration;
  }

  getRequestData() {
    this.viewerRequestApiClient.Get(this.requestId).subscribe({
      next: (requestData) => {
        this.request = requestData;
        this.getPaymentData();
      }
    });
  }

  getPaymentData() {
    if (
      (!this.paymentUrl || this.paymentUrl === '') &&
      Is_VatDeclaration_RequestType(this.request.requestType) &&
      (this.request.status === StatusEnum.Filing || this.request.status === StatusEnum.PendingDigipoort || this.request.status === StatusEnum.Completed) &&
      (!this.request.taxPaymentStatus || this.request.taxPaymentStatus != 'ACSC' && this.request.taxPaymentStatus != 'PDNG')
    ) {
      this.requestService.getPaymentUrl(this.requestId).subscribe({
        next: (data: any) => {
          this.paymentUrl = data;
        },
        error: () => {
          this.paymentUrl = null;
          // error Getting/starting payment session
        },
      });
    }
  }

  pay() {
    if (!this.paymentUrl || this.paymentUrl === '') {
      this.requestService.getPaymentUrl(this.requestId).subscribe({
        next: (data: any) => {
          this.openPopup(data);
        }
      });
      return;
    } else {
      this.openPopup(this.paymentUrl!);
    }
  }

  openPopup(forLink: string) {
    var win = window.open(forLink, "PaymentPopup", "location=0,height=800,width=800")!;
    if (win == null) return;
    let y = this;
    var timer = setInterval(() => {
      if (win.closed) {
        clearInterval(timer);
        y.getRequestData();
        y.checkForTaxPaymentStatus();
      }
    }, 1000);
  }

  private checkForTaxPaymentStatus() {
    let x = 1;
    let y = this;
    let intervalID = setInterval(function () {
      y.getRequestData();
      if (++x === 5 || y.request.taxPaymentStatus) {
        clearInterval(intervalID);
      }
    }, 2000 * x);
  }
}
